import React from 'react'
import Layout from '../Layout'
import classnames from 'classnames'

import styles from './styles.module.less'

const { Content } = Layout

export default ({ children, padder, className, isInner = true }) => {
  const classNames = classnames(styles.content, className, {
    [styles.padder]: padder,
    [styles.appMainContent]: isInner === false,
  })

  return (
    <Content className={classNames}>{children}</Content>
  )
}
